import * as yup from 'yup';
import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { formatDate, isSuccess } from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { trans } from '../../../localization';

export function getProfileNowPortal() {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request.getPortal('/wallet_in_merchant/profile/').then((response) => {
      if (isSuccess(response)) {
        dispatch({
          type: actions.RECEIVE_PROFILE_NOW_PORTAL,
          response: {
            profile: response.reply,
          },
        });
        dispatch(stopAppLoading());
        return response.reply;
      }
      dispatch(setGeneralError(trans(response.result)));
      dispatch(stopAppLoading());
      return {};
    });
  };
}

export function getListStoreNowPortal() {
  return (dispatch) => {
    request.getPortal('/wallet_in_merchant/store/').then((response) => {
      if (isSuccess(response)) {
        const { results: stores } = response.reply;
        dispatch({
          type: actions.RECEIVE_LIST_STORE_NOW_PORTAL,
          response: {
            stores,
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    });
  };
}

export function getListOrderNowPortal(isExport = false) {
  function validate(state, dispatchGeneralError) {
    const { filters } = state;
    const schema = yup.object().shape({
      fromDate: yup
        .date()
        .max(yup.ref('toDate'), trans('from_date_to_date_not_correct'))
        .required(),
      toDate: yup.date().required(),
    });
    try {
      schema.validateSync(filters);
      return true;
    } catch (err) {
      dispatchGeneralError(err.errors[0]);
      return false;
    }
  }

  function genBody(state) {
    const { filters, table } = state;
    const { activePage, pageSize } = table;
    const {
      fromDate, toDate, transactionType, status, store,
    } = filters;
    const body = {
      offset: !isExport ? (activePage - 1) * pageSize : undefined,
      limit: !isExport ? pageSize : undefined,
      date_range: [formatDate(fromDate), formatDate(toDate)],
      status: status && status.value !== 0 ? status.value : undefined,
      payment_channel_ids:
        transactionType && transactionType.value !== 0
          ? [transactionType.value]
          : [],
      store_id: store && store.value !== 0 ? store.value : undefined,
      mode_export: isExport ? 1 : undefined,
    };
    return body;
  }

  return (dispatch, getState) => {
    const state = getState().portal.order;
    if (!validate(state, error => dispatch(setGeneralError(error)))) {
      return null;
    }
    const body = genBody(state);
    dispatch(startAppLoading());
    return request
      .getPortal('/wallet_in_merchant/order/', body)
      .then((response) => {
        if (isSuccess(response)) {
          if (isExport) {
            const exportToken = response.reply.export_token;
            window.open(
              `${CONFIG.API_NOW_PORTAL}/wallet_in_merchant/order/export/${
                state.profile.id
              }/${exportToken}`,
              '_blank',
            );
          } else {
            const { results: itemList, count: totalSize } = response.reply;
            dispatch({
              type: actions.RECEIVE_ORDER_MANAGEMENT_LIST_NOW_PORTAL,
              response: {
                itemList,
                totalSize,
              },
            });
          }
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalOrder/actions.js